import React from 'react'
import { Card } from 'semantic-ui-react';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import { dispatch } from '@rematch/core';
class PlaybookCard extends React.Component {

    async goToPlaybook(selectedPlaybook, data) {
        await dispatch.home.redirectFromEventStream(true);
        await dispatch.lifeCycle.isPlaybookAvailable(selectedPlaybook._id);
        dispatch.lifeCycle.setInitState(selectedPlaybook.status)
        dispatch.createPack.setSelectedActivityData({})
        dispatch.lifeCycle.getPackAndUpdateSelectedPracticeLibary(selectedPlaybook._id);
        dispatch.lifeCycle.isPlaybookImportLoading(false);
        dispatch.lifeCycle.setSelectedPracticeLibrary(selectedPlaybook);
        dispatch.lifeCycle.getInviteByPackIdAsync(selectedPlaybook._id);

        dispatch.lifeCycle.setArrangementPaneFlag(true);
        dispatch.lifeCycle.modalEditOpen(true);
        dispatch.lifeCycle.updateEditCardImageAsync(null);

        dispatch.lifeCycle.setParticipantsAsync([]);
        dispatch.lifeCycle.setInvitedParticipantAsync([]);
        dispatch.lifeCycle.setIdToCenterPosition(selectedPlaybook._id);
        dispatch.lifeCycle.splitAt("60%");
        dispatch.lifeCycle.activePage('libraryCard');
        dispatch.lifeCycle.setPlaybookError(null);
        //this.props.setCollapsedResourcePaneIndex(null);
        dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        switch (selectedPlaybook.status) {
            case 0:
                return dispatch.lifeCycle.showResourecePane("Indesign");
            case 1:
                return dispatch.lifeCycle.showResourecePane("Indesign");
            case 2:
                return dispatch.lifeCycle.showResourecePane("Indesign");
            case 4:
                return dispatch.lifeCycle.showResourecePane("PublishedPack");
            default:
                return null;
        }
    }

    render() {
        return (
            <div className="imageBlock  cursor-pointer" onClick={() => this.goToPlaybook(this.props.selectedPlaybook)}>
                <Card className="appDefaultCard">
                    <Card.Header>
                        <EllipsisTooltip
                            name={this.props.selectedPlaybook.name}
                        />
                    </Card.Header>
                    <Card.Content >
                        <img alt='' className="fitImage" src={this.props.selectedPlaybook.picture} />

                        {this.props.selectedPlaybook.status === 0 ?
                            <div className="badge badgeIndesign">In Design </div>
                            : this.props.selectedPlaybook.status === 1 ? <div className="badge badgeInReview">Review request </div>
                                : this.props.selectedPlaybook.status === 2 ? <div className="badge badgeApproved">Approved </div>
                                    : this.props.selectedPlaybook.status === 3 ? <div className="badge badgeRejected">Rejected </div>
                                        : this.props.selectedPlaybook.status === 4 ? <div className="badge badgePublished">Published </div>
                                            : this.props.selectedPlaybook.status === 5 ? <div className="badge badgeDepricated">Inactive </div>
                                                : this.props.selectedPlaybook.status === 6 ? <div className="badge badgeCloned">Cloned / Purchased </div>
                                                    : ''}

                        <div className="badgeRight">
                            <span
                                className={`badgeblock ${this.props.selectedPlaybook.scope === 'Public' ? 'badgeRightPublic' : ''} ${this.props.selectedPlaybook.scope === 'Private' ? 'badgeRightPrivate' : ''}`}>
                                {this.props.selectedPlaybook.scope === "Private" ? "Workspace" : this.props.selectedPlaybook.scope}
                            </span>
                        </div>
                    </Card.Content>
                </Card>
            </div>
        )
    }
}

export default PlaybookCard;
